module.exports = __webpack_public_path__ + "img/left-color-oval.acdfa6a8.png";